// extracted by mini-css-extract-plugin
export default {"package":"package_package__FZCs4","animated":"package_animated__aKqyV","hovered":"package_hovered__MSdNM","jump-shaking":"package_jump-shaking__t8xY9"};